import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  TableBody,
  TableCell,
  TableRow,
  Switch,
  FormControlLabel,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import useTable from '../../../../components/useTable';

const header = [
  { id: 'calendarId', label: 'Calendar ID' },
  { id: 'calendarName', label: 'Calendar Name' },
  { id: 'provider', label: 'Provider' },
  { id: 'notification', label: 'Send Notification' },
  { id: 'deleteCalendar', label: 'Remove' },
];

export default function TelusCalendarTable(props) {
  const { calendars, setCalendars } = props;

  const deleteCalendar = (id) => {
    setCalendars(calendars.filter((item) => item.id !== id));
  };

  const handleNotificationToggle = (calendarId) => {
    setCalendars(calendars.map((calendar) => {
      if (calendar.id === calendarId) {
        return { ...calendar, sendNotification: !calendar.sendNotification };
      }
      return calendar;
    }));
  };

  const formatProviderName = (provider) => {
    if (!provider) return 'No provider assigned';
    if (provider.userDetail) {
      return `${provider.userDetail.firstName} ${provider.userDetail.lastName}`;
    }
    // Fallback for old format if needed
    return `${provider.firstName || ''} ${provider.lastName || ''}`;
  };

  const {
    TblContainer,
    TblHead,
    currentPageDataSorted,
  } = useTable(calendars, header, { fn: (items) => items });

  return (
    <TblContainer>
      <TblHead />
      <TableBody>
        {calendars && currentPageDataSorted().map((calendar) => (
          <TableRow key={calendar.id}>
            <TableCell>{calendar.id}</TableCell>
            <TableCell>{calendar.name}</TableCell>
            <TableCell>{formatProviderName(calendar.provider)}</TableCell>
            <TableCell>
              <FormControlLabel
                control={(
                  <Switch
                    checked={calendar.sendNotification}
                    onChange={() => handleNotificationToggle(calendar.id)}
                    color="primary"
                  />
                )}
                label={calendar.sendNotification ? 'On' : 'Off'}
              />
            </TableCell>
            <TableCell>
              <IconButton onClick={() => deleteCalendar(calendar.id)}>
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TblContainer>
  );
}

TelusCalendarTable.propTypes = {
  calendars: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      provider: PropTypes.shape({
        userDetail: PropTypes.shape({
          providerId: PropTypes.string,
          defaultScheduleId: PropTypes.string,
          firstName: PropTypes.string,
          lastName: PropTypes.string,
          role: PropTypes.string,
          roleType: PropTypes.string,
        }),
        type: PropTypes.string,
        canReceiveMessage: PropTypes.bool,
        services: PropTypes.arrayOf(PropTypes.string),
        id: PropTypes.string,
        descriptor: PropTypes.string,
      }),
      sendNotification: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  setCalendars: PropTypes.func.isRequired,
};
